/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Dialog_Add_LotInputs */

const vi_stock_out_dialog_add_lot = /** @type {(inputs: Stock_Out_Dialog_Add_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô`)
};

/**

* @param {Stock_Out_Dialog_Add_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_dialog_add_lot = /** @type {((inputs?: Stock_Out_Dialog_Add_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Dialog_Add_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_dialog_add_lot(inputs)
});